import { DeleteOutlined, FileTextTwoTone } from '@ant-design/icons';
import { List, Upload } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import React from 'react';
import i18n from '../../../i18n/config';
import { ALLOWED_FILE_TYPES, COLORS } from '../../../shared';
import { getFileIconByType } from '../../../utils';
import { HasText } from '../../atoms';

interface FileUploadProps {
  files: UploadFile[];
  onChange: (files: UploadFile[]) => void;
  accept?: string;
  multiple?: boolean;
}

class HasFileUpload extends React.Component<FileUploadProps, {}> {
  handleChange = (info: { file: UploadFile }) => {
    const { files, onChange } = this.props;
    const exists = files.some((existingFile) => existingFile.uid === info.file.uid);
    onChange(exists ? files : [...files, info.file]);
  };

  handleRemove = (file: UploadFile) => {
    const { files, onChange } = this.props;
    onChange(files.filter((item) => item.uid !== file.uid));
  };

  render() {
    const { files, accept, multiple = true } = this.props;
    return (
      <>
        <Upload.Dragger
          multiple={multiple}
          accept={accept ?? Object.values(ALLOWED_FILE_TYPES).flat().join(',')}
          onChange={this.handleChange}
          onRemove={this.handleRemove}
          showUploadList={false}
          style={{ padding: 16 }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 16,
            }}
          >
            <FileTextTwoTone twoToneColor={[COLORS.GRAY_DARKISH, COLORS.GRAY_ACCENT_LIGHT]} style={{ fontSize: 32 }} />
            <HasText content={i18n.t('action.dropZoneText', 'Click here or drag files to upload')} />
          </div>
        </Upload.Dragger>
        {files.length > 0 && (
          <List
            dataSource={files}
            renderItem={(file) => (
              <List.Item style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  {getFileIconByType(file.type, { fontSize: 32 })}
                  <HasText content={file.name} />
                </div>
                <DeleteOutlined
                  onClick={() => this.handleRemove(file)}
                  style={{ padding: '10px' }}
                  className="icon-hover danger"
                />
              </List.Item>
            )}
          />
        )}
      </>
    );
  }
}

export default HasFileUpload;
